var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21V3L12 4L14 3L15.9963 4L18.0194 3L20 4L21.9869 3L23.9825 4L26 3L28.0006 4L30 3V17",
    stroke: "#192BC2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17V24C30 25.3261 29.4733 26.5979 28.5356 27.5355C27.5979 28.4732 26.3261 29 25 29M25 29C23.674 29 22.4022 28.4732 21.4645 27.5355C20.5268 26.5979 20 25.3261 20 24V21H3.00004C2.86839 20.9988 2.73783 21.0239 2.61598 21.0737C2.49413 21.1236 2.38342 21.1972 2.29033 21.2903C2.19724 21.3834 2.12362 21.4941 2.07378 21.6159C2.02394 21.7378 1.99887 21.8684 2.00004 22C2.00004 26 2.42129 29 7.00004 29H25Z",
    stroke: "#192BC2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H26M18 14H26",
    stroke: "#192BC2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/Receipt.351fcc34ee715b39d5c00074a465d00a.svg";
export { ForwardRef as ReactComponent };